module.exports = __webpack_public_path__ + "static/img/10_10commitments_10milliards.a46cbed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10_10commitments_10milliards.jpg
// module id = 40dg
// module chunks = 0